module.exports = __webpack_public_path__ + "img/jian.1ad0a265.png";